import { groupBy } from '@utils/helpers';
import DotSvg from 'front/assets/other-icons/dot.svg';
import { useCallback } from 'react';
import { usePaginationFragment } from 'react-relay';
import { awardsListBlockFragment } from './AwardsListBlock.relay';
import { AwardsListItem } from './lib/AwardsListItem';
import type { AwardsListBlockPropsType } from './types';

const AwardsListBlock: React.FC<AwardsListBlockPropsType> = (props: AwardsListBlockPropsType) => {
  const { data, loadPrevious, hasPrevious, isLoadingPrevious } = usePaginationFragment(awardsListBlockFragment, props.contentBlock);

  const getMoreAwards = useCallback(() => {
    if (!hasPrevious || isLoadingPrevious) {
      return;
    }

    loadPrevious(4, {
      onComplete: (error) => {
        if (error) {
          console.error('Error loading more awards:', error);
        }
      },
    });
  }, [hasPrevious, isLoadingPrevious, loadPrevious]);

  const awardYears = Object.entries(groupBy(data.items?.edges?.map((itemNode) => itemNode?.node).filter(Boolean) || [], 'year'));

  awardYears.sort((a: any, b: any) => {
    return b[0] - a[0];
  });

  return (
    <section className="my-[35px] first:mt-0">
      <header className="border-b border-black">
        <h3 className="inline-block border-b border-accent self-start text-black leading-[26px] -mb-px p-0">{data.awardsTitle}</h3>
      </header>
      {awardYears.map((item, i) => (
        <div className={i < awardYears.length - 1 ? 'border-b border-[#e2e2e2]' : ''} key={i}>
          <h3 className="font-normal text-2xl leading-6 text-[#e2e2e2] p-[35px]">{item[0]}</h3>
          {item[1].map((subItem: any, j: number) => (
            <AwardsListItem key={j} awardsListItem={subItem} />
          ))}
        </div>
      ))}
      <div className="flex justify-center items-center pt-[35px]">
        {hasPrevious && (
          <button
            type="button"
            onClick={getMoreAwards}
            className="inline-block min-w-[200px] max-w-[300px] cursor-pointer rounded-[15px] border border-black bg-white px-5 py-1.5 text-sm font-normal font-[BonnCaps,Arial,sans-serif] uppercase tracking-wide text-accent outline-none my-2.5 max-[1100px]:w-full max-[1100px]:max-w-full disabled:cursor-not-allowed [&_svg]:mx-0.5"
            disabled={isLoadingPrevious}
          >
            <DotSvg />
            <DotSvg />
            <DotSvg />
          </button>
        )}
      </div>
    </section>
  );
};

export { AwardsListBlock };
